import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utils/axiosConfig";

/* =======================  Styles (same as first version)  ======================= */
const CSS_ONCE = `
.invest-wrap { margin: 1% 1% 30px; border-bottom: 1px solid #E5EAED; font-family: Poppins, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial; }
.invest-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;  margin-top:10px; }
.invest-title { font-weight:600; font-size:18px; color:#000; }
.btn { border:0; cursor:pointer; transition:all .18s ease; display:inline-flex; align-items:center; justify-content:center; }
.btn-primary { background:rgb(60, 101, 86); color:#fff; border-radius:6px; font-size:12px; font-weight:500; padding:8px 12px; margin-top:10px; }
.btn-primary:hover { filter:brightness(.95); }
.btn-danger { color:#ff3636; background:#ffe5e5; border-radius:6px; font-size:12px; font-weight:600; padding:8px 12px; }
.btn-validate { background:rgb(60, 101, 86); color:#fff; border-radius:6px; font-size:12px; font-weight:600; padding:8px 12px; }

/* delete button (small, top-right) */
.btn-delete {
  margin-left:auto;
  background:#FFE5E5;
  color:#E11D48;
  border-radius:6px;
  font-size:12px;
  font-weight:600;
  padding:6px 10px;
}
.btn-delete:hover { filter:brightness(.98); }

.modal-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.35); display:flex; align-items:center; justify-content:center; z-index:999; }
.modal { width:min(980px,95vw); background:#fff; box-shadow:0 25px 50px rgba(0,0,0,.25); border-radius:8px; overflow:hidden; }
.modal-head { background:#f3f6f9; border-bottom:1px solid #E5EAEE; padding:16px 20px; display:flex; align-items:center; justify-content:space-between; }
.modal-title { font-weight:700; font-size:22px; color:#0b1324; }
.modal-dossier { color:rgb(187, 200, 8); font-weight:700; margin-left:8px; }
.modal-close { border:0; background:transparent; font-size:22px; color:rgb(60, 101, 86); cursor:pointer; }
.modal-body { padding:18px 20px; }
.modal-grid { display:grid; gap:16px; grid-template-columns: repeat(12, 1fr); }
.col-6 { grid-column: span 12; }
@media (min-width: 740px) { .col-6 { grid-column: span 6; } }
.col-12 { grid-column: span 12; }

.form-field { display:flex; flex-direction:column; gap:8px; }
.label { font-weight:600; color:rgb(60, 101, 86); font-size:14px; }
.input, .select-like, .textarea { width:100%; border:1px solid #D9DEE3; border-radius:8px; padding:12px 12px; font:14px Poppins, sans-serif; color:#111827; background:#F8FAFC; }
.input:focus, .textarea:focus, .select-like:focus { outline:none; border-color:rgb(60, 101, 86); box-shadow:0 0 0 3px rgba(60, 101, 86, .14); }
.input[readonly] { background:#F3F6F9; }

.select-shell { position:relative; }
.select-like { display:flex; align-items:center; gap:8px; cursor:pointer; background:#F8FAFC; }
.select-like.disabled { color:#9CA3AF; cursor:not-allowed; }
.select-placeholder { color:#9CA3AF; }
.chev-down { margin-left:auto; border-left:6px solid transparent; border-right:6px solid transparent; border-top:6px solid #6b7280; width:0; height:0; }
.dropdown { position:absolute; top:calc(100% + 6px); left:0; right:0; background:#fff; border:1px solid #E5EAEE; border-radius:8px; box-shadow:0 12px 30px rgba(0,0,0,.15); z-index:30; max-height:260px; overflow:auto; }
.dropdown-item { padding:11px 12px; font-size:14px; color:#111827; cursor:pointer; }
.dropdown-item:hover { background:##ebeff2ff; }
.dropdown-item[aria-selected="true"] { background:##ebeff2ff; }

.modal-foot { background:#f3f6f9; border-top:1px solid #ebeff2ff; padding:14px 20px; display:flex; gap:10px; justify-content:flex-end; }

.accord { margin: 14px 0 24px; }
.item { border:1px solid rgb(60, 101, 86); border-radius:11px; margin-bottom:12px; overflow:hidden; background:#fff; }
.item-head { display:flex; align-items:center; gap:10px; min-height:48px; background:##ebeff2ff; padding:10px 12px; cursor:pointer; border-bottom:1px solid ##ebeff2ff; }
.chev { width:22px; height:22px; border-radius:5px; background:rgb(60, 101, 86); color:#fff; display:flex; align-items:center; justify-content:center; font-weight:700; }
.item-title { color:#002226; font-size:15px; font-weight:600; line-height:21px; flex:1; }
.badge-fraude { height:22px; border-radius:999px; background:#FFE7E6; color:#E66A5E; padding:2px 12px; font-size:11px; display:flex; align-items:center; }
.item-body { background:#fff; padding:18px 20px; }
.row { display:grid; gap:12px; grid-template-columns: repeat(12, 1fr); margin-bottom:6px; }
.cell { grid-column: span 12; }
@media (min-width: 820px) { .cell { grid-column: span 3; } }
.field-title { font-weight:600; margin-bottom:6px; color:#111827; font-size:13px; }
.field-pill { background:#F9FAFB; border:1px solid #E5EAED; border-radius:8px; padding:10px; min-height:40px; color:#111827; }
.value-fraude { color:#E66A5E; font-weight:600; }
.rapport-box { background:#ebeff2ff; color:rgb(60, 101, 86); border-radius:8px; padding:12px; border:1px solid ##ebeff2ff; }
.loading { opacity:.75; font-style:italic; }
`;



function useOnceCss(cssText) {
    useEffect(() => {
        const id = "investigation-css-once";
        if (document.getElementById(id)) return;
        const style = document.createElement("style");
        style.id = id;
        style.textContent = cssText;
        document.head.appendChild(style);
    }, [cssText]);
}

/* =======================  Data  ======================= */
const motifOptions = [
    "1 – Choc Antérieur",
    "2 – Dommage déjà indemnisé ou déclaré",
    "3 – Fraude à l'usage (Location, taxi, auto-école)",
    "4 – Usage de faux documents (Facture, PV)",
    "5 – Accident combiné",
    "6 – Matérialité non prouvé",
    "7 – Conduite en état d'ivresse",
    "8 – Absence de l'élément sinistré le jour du sinistre",
    "9 – Choc incompatible",
];

/* =======================  Component  ======================= */
export default function Investigations({ claimNumber, relatedClaimUid }) {
    useOnceCss(CSS_ONCE);

    const [modalOpen, setModalOpen] = useState(false);
    const [decision, setDecision] = useState("");
    const [motif, setMotif] = useState("");
    const [rapport, setRapport] = useState("");
    const [investigations, setInvestigations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openIndexes, setOpenIndexes] = useState({});

    // Dropdown state
    const [motifOpen, setMotifOpen] = useState(false);
    const motifShellRef = useRef(null);

    // Ensure env is like: https://api.unfrauded.com/api/investigation
    const baseUrl =  "https://maeprep.unfrauded.com/apiv2/api/investigation"
    const listEndpoint = `${baseUrl}/investigation`;      // GET all
    const createEndpoint = `${baseUrl}/investigation`;    // POST create
    const deleteEndpoint = (id) => `${baseUrl}/investigation/${encodeURIComponent(id)}`; // DELETE by _id
    console.log("listEndpoint", listEndpoint);
    console.log("baseUrl", baseUrl);
    // Fetch ALL, then filter by claimNumber
    const fetchInvestigations = async () => {
        if (!claimNumber) return;
        setLoading(true);
        try {
            const res = await axiosInstance.get(listEndpoint);
            const all = Array.isArray(res?.data) ? res.data : [];
            const filtered = all.filter(
                (inv) => (inv?.claimNumber || "").toString().trim() === (claimNumber || "").toString().trim()
            );
            setInvestigations(filtered);
        } catch (error) {
            console.error("Error fetching investigations list:", error);
            setInvestigations([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        try {
            if (!claimNumber) {
                alert("Impossible de valider : claimNumber est manquant.");
                return;
            }
            if (decision === "Fraude" && !motif) {
                alert("Merci de sélectionner un motif pour la fraude.");
                return;
            }

            const payload = {
                titre: `Investigation ${claimNumber}`,
                state: decision === "Fraude" ? "Completed" : "Not Started",
                priority: "Medium",
                commentaires: rapport || "",
                claimNumber, // ✅ obligatoire
                ...(relatedClaimUid ? { relatedClaimUid } : {}),
                ...(motif ? { motif } : {}),
                listeInvestigationAction: [],
                listeCause: [],
                listeFormID: [],
                userID: "000000000000000000000000",
                assigne: "000000000000000000000000",
            };

            await axiosInstance.post(createEndpoint, payload, {
                headers: { "Content-Type": "application/json" },
            });

            // After create, always refetch list → filter → render
            setModalOpen(false);
            setDecision("");
            setMotif("");
            setRapport("");
            fetchInvestigations();
        } catch (error) {
            console.error("Error creating investigation:", error);
            const apiMsg =
                error?.response?.data?.errors?.join(" • ") ||
                error?.response?.data?.message ||
                "Erreur lors de la création de l'investigation.";
            alert(apiMsg);
        }
    };

    const handleDelete = async (inv) => {
        try {
            if (!inv?._id) return;
            await axiosInstance.delete(deleteEndpoint(inv._id));
            await fetchInvestigations();
        } catch (error) {
            console.error("Error deleting investigation:", error);
            const apiMsg =
                error?.response?.data?.errors?.join(" • ") ||
                error?.response?.data?.message ||
                "Suppression impossible.";
            alert(apiMsg);
        }
    };

    // Fetch on mount and when claimNumber changes
    useEffect(() => {
        fetchInvestigations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [claimNumber]);

    // Refetch when tab regains focus or becomes visible
    useEffect(() => {
        const onFocus = () => fetchInvestigations();
        const onVisibility = () => {
            if (document.visibilityState === "visible") fetchInvestigations();
        };
        window.addEventListener("focus", onFocus);
        document.addEventListener("visibilitychange", onVisibility);
        return () => {
            window.removeEventListener("focus", onFocus);
            document.removeEventListener("visibilitychange", onVisibility);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [claimNumber]);

    // Close motif dropdown on outside click
    useEffect(() => {
        const onDocClick = (e) => {
            if (motifShellRef.current && !motifShellRef.current.contains(e.target)) {
                setMotifOpen(false);
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    const toggleIndex = (i) => setOpenIndexes((prev) => ({ ...prev, [i]: !prev[i] }));

    const hasInvestigation = investigations.length > 0;

    return (
        <div className="invest-wrap">
            <div className="invest-topbar">
                <div className="invest-title">                       </div>
                {/* Hide "Avis Gestionnaire" when there is already an investigation */}
                {!hasInvestigation && (
                    <button className="btn btn-primary" onClick={() => setModalOpen(true)}>
                        Avis Gestionnaire
                    </button>
                )}
            </div>

            {/* Modal */}
            {modalOpen && (
                <div className="modal-backdrop" onClick={() => setModalOpen(false)}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-head">
                            <div className="modal-title">
                                Analyse du dossier N° <span className="modal-dossier">{claimNumber || "—"}</span>
                            </div>
                            <button className="modal-close" onClick={() => setModalOpen(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            <div className="modal-grid">
                                {/* Décision */}
                                <div className="col-6">
                                    <div className="form-field">
                                        <label className="label">Décision Gestionnaire</label>
                                        <select
                                            className="input"
                                            value={decision}
                                            onChange={(e) => {
                                                setDecision(e.target.value);
                                                if (e.target.value !== "Fraude") setMotif("");
                                            }}
                                        >
                                            <option value="">— Choisir —</option>
                                            <option value="Fraude">Fraude</option>
                                            <option value="Non fraude">Non fraude</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Motif dropdown */}
                                <div className="col-6">
                                    <div className="form-field">
                                        <label className="label">Motif</label>
                                        <div className="select-shell" ref={motifShellRef}>
                                            <button
                                                type="button"
                                                className={`select-like${decision !== "Fraude" ? " disabled" : ""}`}
                                                onClick={() => decision === "Fraude" && setMotifOpen((v) => !v)}
                                            >
                                                <span className={motif ? "" : "select-placeholder"}>
                                                    {motif || "Motif"}
                                                </span>
                                                <span className="chev-down" />
                                            </button>
                                            {motifOpen && decision === "Fraude" && (
                                                <div className="dropdown">
                                                    {motifOptions.map((opt) => (
                                                        <div
                                                            key={opt}
                                                            className="dropdown-item"
                                                            aria-selected={motif === opt}
                                                            onClick={() => {
                                                                setMotif(opt);
                                                                setMotifOpen(false);
                                                            }}
                                                        >
                                                            {opt}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Rapport */}
                                <div className="col-12">
                                    <div className="form-field">
                                        <label className="label">Rapport d'analyse</label>
                                        <textarea
                                            className="textarea"
                                            placeholder="Rédiger le rapport ici..."
                                            value={rapport}
                                            onChange={(e) => setRapport(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-foot">
                            <button className="btn btn-danger" onClick={() => setModalOpen(false)}>
                                Annuler
                            </button>
                            <button
                                className="btn btn-validate"
                                onClick={() => {
                                    if (decision === "Fraude" && !motif) {
                                        alert("Merci de sélectionner un motif pour la fraude.");
                                        return;
                                    }
                                    handleSubmit();
                                }}
                            >
                                Valider
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Accordion */}
            {loading ? (
                <div className="loading">Chargement…</div>
            ) : (
                <div className="accord">
                    {investigations.map((inv, i) => {
                        const opened = !!openIndexes[i];
                        const isFraude = inv.state === "Completed";
                        return (
                            <div key={inv._id || i} className="item">
                                <div className="item-head" onClick={() => toggleIndex(i)}>
                                    <div className="chev">{opened ? "–" : "+"}</div>
                                    <div className="item-title">
                                        {inv.titre || "Investigation"}{" "}
                                        {isFraude && <span className="badge-fraude">Fraude</span>}
                                    </div>

                                    {/* Supprimer (top-right) */}
                                    <button
                                        className="btn btn-delete"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDelete(inv);
                                        }}
                                        title="Supprimer l'investigation"
                                    >
                                        Supprimer
                                    </button>
                                </div>

                                {opened && (
                                    <div className="item-body">
                                        <div className="row">
                                            <div className="cell">
                                                <div className="field-title">Décision</div>
                                                <div className={`field-pill ${isFraude ? "value-fraude" : ""}`}>
                                                    {inv.state}
                                                </div>
                                            </div>
                                            <div className="cell">
                                                <div className="field-title">Priorité</div>
                                                <div className="field-pill">{inv.priority}</div>
                                            </div>
                                            <div className="cell">
                                                <div className="field-title">Commentaire</div>
                                                <div className="field-pill">{inv.commentaires}</div>
                                            </div>
                                            <div className="cell">
                                                <div className="field-title">N° Sinistre</div>
                                                <div className="field-pill">{inv.claimNumber || claimNumber || "—"}</div>
                                            </div>
                                            {inv.motif && (
                                                <div className="cell">
                                                    <div className="field-title">Motif</div>
                                                    <div className="field-pill">{inv.motif}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}

                    {/* Empty state: no investigation for this claim */}
                    {!loading && investigations.length === 0 && (
                        <div className="item">
                            <div className="item-head">
                                <div className="chev">•</div>
                                <div className="item-title">Aucune investigation pour ce sinistre.</div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
